import React, {useCallback} from "react";
import styled from "styled-components";
import {MenuItem} from "@mui/material";
import {Input} from "components/styled";
import {useSelector} from "react-redux";
import {getRoundsFrom} from "modules/selectors";
import {media} from "assets/media";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	padding: 0 0 30px 0;

	${Input} {
		max-width: 300px;
	}

	@media screen and ${media.lessThanSM} {
		flex-direction: column;

		${Input} {
			max-width: unset;
			width: 100%;
		}
	}
`;

interface IProps {
	leagueStartRound: number;
	round: number;
	setRound: (round: number) => void;
}

export const LeagueTableFilters: React.FC<IProps> = ({leagueStartRound, round, setRound}) => {
	const rounds = useSelector(getRoundsFrom)(leagueStartRound);
	const {t} = useTranslation();

	const onRoundChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setRound(Number(e.target.value));
		},
		[setRound]
	);

	return (
		<Wrapper>
			<Input select label="Type" name="type" value={round} onChange={onRoundChange}>
				<MenuItem value={0} selected={true}>
					{t("league.body.filter_overall")}
				</MenuItem>
				{rounds.map((round) => (
					<MenuItem key={round.id} value={round.id}>
						{t(`team.summary.filter_gw${round.number}`)}
					</MenuItem>
				))}
			</Input>
		</Wrapper>
	);
};
